import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  isLoggedIn$: BehaviorSubject<boolean>;
  private logged: boolean = false;

  constructor() {
    // this.isLoggedIn$ = new BehaviorSubject(environment.skipLogin || false);
  }

  public isLogged(): boolean {
    return this.logged || false;
  }

  public setLogged(login: boolean): void {
    this.isLoggedIn$.next(login);
    this.logged = login;
  }

}
